import React from 'react';
import { Chip } from '@mui/material';

import {
  daysSinceEra,
  eraAgeTone,
  formatEraAge,
} from '../../../utils/secondaryBillingPresentation';

export interface EraAgeChipProps {
  /** The row's `primary_era_at`: when the primary's driving 835 arrived. */
  primaryEraAt: string | null | undefined;
}

/**
 * How long the primary's 835 has been sitting: "64 days", amber from thirty
 * and red from sixty (GDN-4023). The same chip on the Home card and in the
 * Claims tab's "Days since ERA" column, so the two surfaces colour the same
 * claim the same way.
 *
 * Nothing at all without a date. The queue's predicate requires an 835, so
 * a row without one is a gap on the server's side, not a fact to print as
 * "0 days".
 */
export const EraAgeChip: React.FC<EraAgeChipProps> = ({ primaryEraAt }) => {
  const days = daysSinceEra(primaryEraAt);
  if (days == null) return null;
  return (
    <Chip
      color={eraAgeTone(days)}
      data-testid="era-age-chip"
      label={formatEraAge(days)}
      size="small"
      sx={{ flexShrink: 0, fontWeight: 600 }}
    />
  );
};
